// extracted by mini-css-extract-plugin
export default {"green_button":"BtnGreen_green_button__s7ITh"};